/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { LANDINGPAGE } from '../../../../commons/api';
import localStorage from '../../../../utils/localStorage';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import { Form, Input, Drawer, Button, message, Popconfirm, Select } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';

const { Option } = Select;

const LandingPage = ({ translationCache }) => {
  const [visible, setVisible] = useState(false);
  const [datasource, setDatasource] = useState([]);
  const [editObj, setEditObj] = useState({});
  const [searchText, setSearchText] = useState('');
  const [translationCacheState, setTranslationCache] = useState(translationCache || {});
  const departmentRef = useRef(null);
  const searchInputRef = useRef(null);

  useEffect(() => {
    _getLandingPageList();
  }, []);

  useEffect(() => {
    if (translationCache !== translationCacheState) {
      setTranslationCache(translationCache);
    }
  }, [translationCache]);

  const _getLandingPageList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${LANDINGPAGE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        setDatasource(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const openModal = () => {
    if (departmentRef.current) {
      departmentRef.current.resetFields();
    }
    setVisible(true);
    setEditObj({});
  };

  const _cancel = () => {
    if (departmentRef.current) {
      departmentRef.current.resetFields();
    }
    setVisible(false);
    setEditObj({});
  };

  const editLandingPage = (record) => {
    if (departmentRef.current) {
      departmentRef.current.setFieldsValue(record);
    }
    setEditObj(record);
    setVisible(true);
  };

  const _createLandingPage = (e) => {
    e.preventDefault();
    departmentRef.current
      .validateFields()
      .then(async (values) => {
        _createLandingPageAPI(values);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _updateLandingPage = (e) => {
    e.preventDefault();
    departmentRef.current
      .validateFields()
      .then(async (values) => {
        const updateObject = {
          ...values,
          Id: editObj.Id
        };
        _updateLandingPageAPI(updateObject);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _deleteLandingPage = (Id) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgDeleteHeaders = {
      method: 'DELETE',
      url: `${LANDINGPAGE.DELETE}?SiteId=${siteId}&Id=${Id}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(orgDeleteHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          message.success('LandingPage Deleted');
          _getLandingPageList();
          setVisible(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _createLandingPageAPI = (createObject) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgCreateHeaders = {
      method: 'POST',
      url: `${LANDINGPAGE.CREATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: { ...createObject, SiteId: siteId }
    };
    axios(orgCreateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success('LandingPage Saved');
          _getLandingPageList();
          setVisible(false);
          if (departmentRef.current) {
            departmentRef.current.resetFields();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const _updateLandingPageAPI = (updateObject) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let orgUpdateHeaders = {
      method: 'PATCH',
      url: `${LANDINGPAGE.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: updateObject
    };
    axios(orgUpdateHeaders)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          message.success('LandingPage Updated');
          _getLandingPageList();
          setVisible(false);
          setEditObj({});
          if (departmentRef.current) {
            departmentRef.current.resetFields();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const renderFormSwitch = (renderFormItems) => {
    const { disableOnUpdate } = renderFormItems;
    switch (renderFormItems.Widget) {
      case 'Select':
        return (
          <Select
            style={{ width: 350 }}
            placeholder={`Select ${renderFormItems.Key}`}
            onChange={(e) =>
              departmentRef.current.setFieldsValue({ [renderFormItems.Key]: e })
            }
          >
            {renderFormItems.Options &&
              renderFormItems.Options.map((option, index) => {
                if (
                  renderFormItems.OptionsSettings &&
                  renderFormItems.OptionsSettings.key &&
                  renderFormItems.OptionsSettings.value
                ) {
                  return (
                    <Option key={index} value={option[renderFormItems.OptionsSettings.value]}>
                      {option[renderFormItems.OptionsSettings.key]}
                    </Option>
                  );
                }
                return (
                  <Option key={index} value={option}>
                    {option}
                  </Option>
                );
              })}
          </Select>
        );

      default:
        return (
          <Input
            style={{ width: 350 }}
            placeholder={translation(`Enter ${renderFormItems.Key}`)}
            disabled={disableOnUpdate ? true : false}
          />
        );
    }
  };

  const onFinishFailed = () => {
    message.error('please enter required fields');
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={translation(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation('Search')}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation('Reset')}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    ),
  });

  const columns = [
    {
      title: translation('Landing Page Name'),
      dataIndex: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: translation('LandingPage Code'),
      dataIndex: 'Code',
      ...getColumnSearchProps('Code')
    },
    {
      title: translation('Description'),
      dataIndex: 'Description',
      ...getColumnSearchProps('Description')
    },
    {
      title: translation('Path'),
      dataIndex: 'Path',
      ...getColumnSearchProps('Path')
    },
    {
      title: translation('Action'),
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            onClick={() => editLandingPage(record)}
            style={{ marginRight: '10px' }}
          >
            <EditOutlined />
          </Button>

          {record && record.Default && record.Default !== true ? (
            <Popconfirm
              title={translation('Are you sure delete LandingPage ?')}
              onConfirm={(e) => {
                e.stopPropagation();
                _deleteLandingPage(record.Id);
              }}
              okText={translation('Yes')}
              cancelText={translation('No')}
            >
              <Button type="primary">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          ) : null}
        </div>
      )
    }
  ];

  const formStructure = [
    {
      DisplayName: 'Name',
      Key: 'Name',
      Widget: 'Input'
    },
    {
      DisplayName: 'Code',
      Key: 'Code',
      Widget: 'Input'
    },
    {
      DisplayName: 'Description',
      Key: 'Description',
      Widget: 'Input'
    },
    {
      DisplayName: 'Path',
      Key: 'Path',
      Widget: 'Input'
    }
  ];

  return (
    <>
      <Drawer
        title={!editObj.Id ? translation('Create LandingPage') : translation('Update LandingPage')}
        open={visible}
        width={600}
        closable
        onClose={_cancel}
      >
        <Form
          layout="vertical"
          ref={departmentRef}
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          name="user_form"
          initialValues={editObj || {}}
          onFinishFailed={onFinishFailed}
        >
          {formStructure &&
            Array.isArray(formStructure) &&
            formStructure.map((formItem, index) => (
              <Form.Item
                key={index}
                name={formItem.Key}
                label={translation(formItem.DisplayName)}
              >
                {renderFormSwitch(formItem)}
              </Form.Item>
            ))}
        </Form>
        <DrawerFooter>
          <Button onClick={_cancel} type='primary' style={{ marginRight: 8 }}>
            {translation('Cancel')}
          </Button>
          {!editObj.Id ? (
            <Button type="primary" onClick={_createLandingPage}>
              {translation('Create')}
            </Button>
          ) : (
            <Button type="primary" onClick={_updateLandingPage}>
              {translation('Update')}
            </Button>
          )}
        </DrawerFooter>
      </Drawer>
      <Button
        type="primary"
        style={{
          marginBottom: '10px',
        }}
        onClick={openModal}
      >
        <PlusOutlined /> {translation('Add')}
      </Button>
      <StyledTable size="small"
        columns={columns}
        dataSource={datasource}
        pagination={
          datasource.length > 10
            ? {
              pageSize: '10'
            }
            : false
        }
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(LandingPage);
